module.exports = __webpack_public_path__ + "img/IMG_1079.429047f0.png";